<div class="row">
    <div class="col-xl-6">
        <div class="card card-box mb-5">
            <div class="card-header">
                <div class="card-header--title">
                    <h4 class="font-size-lg mb-0 py-2 font-weight-bold">
                        Income Reports
                    </h4>
                </div>
                <div class="card-header--actions">
                    <div class="btn-group btn-group-sm" dropdown>
                        <button class="btn btn-sm dropdown-toggle no-caret btn-neutral-first" dropdownToggle
                                type="button">
                            Export
                            <fa-icon [icon]="['fas', 'chevron-down']" class="opacity-8 font-size-xs ml-1"></fa-icon>
                        </button>
                        <div *dropdownMenu class="dropdown-menu dropdown-menu-xl dropdown-menu-right">
                            <ul class="nav nav-neutral-dark nav-pills flex-column px-3">
                                <li class="nav-item nav-item--header px-0">
                                    <span class="text-capitalize text-black font-size-md font-weight-bold">Export menu</span>
                                </li>
                                <li class="dropdown-divider"></li>
                                <li class="nav-item">
                                    <a [routerLink]="" class="nav-link">
                                        <span>View all reports</span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a [routerLink]="" class="nav-link active">
                                        <span>View active items</span>
                                        <div class="ml-auto badge badge-success">23</div>
                                    </a>
                                </li>
                                <li class="nav-item pt-4 nav-item--header">
                                    <span class="text-black font-weight-bold">Options</span>
                                </li>

                                <li class="nav-item">
                                    <a [routerLink]="" class="nav-link">
                                        <div class="nav-link-icon">
                                            <fa-icon [icon]="['fas', 'download']"></fa-icon>
                                        </div>
                                        <span>Download</span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a [routerLink]="" class="nav-link">
                                        <div class="nav-link-icon">
                                            <fa-icon [icon]="['far', 'file-excel']"></fa-icon>
                                        </div>
                                        <span>Export to CSV</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body pb-1 font-weight-bold">
                <div class="row pt-3">
                    <div class="col-md-5">
                        <div class="pb-4 px-3">
                            <span class="text-dark pb-4">YoY Income</span>
                            <span class="font-size-lg d-block">
                                <small>$</small> 165,239
                            </span>
                        </div>
                        <div class="pb-4 px-3">
                            <span class="text-dark pb-4">Orders Volume</span>
                            <span class="font-size-lg d-block">
                                <small>$</small> 384
                            </span>
                        </div>
                    </div>
                    <div class="col-md-7">
                        <div class="pb-4 px-3">
                            <span class="text-dark pb-4">Best Seller</span>
                            <span class="font-size-lg d-block">
                                Personal Computer
                            </span>
                        </div>
                        <div class="pb-4 px-3">
                            <span class="text-dark pb-4">Sales Target</span>
                            <span class="d-flex align-items-center font-size-lg d-block">
                                <progressbar
                                        class="progress-striped active progress-sm progress-bar-animated progress-bar-rounded"
                                        type="warning" value="65"></progressbar>
                                <span class="pl-3">65%</span>
                            </span>
                        </div>
                    </div>
                </div>
                <apx-chart
                        [chart]="{
                                type: 'area',
                                height: '311',
                                sparkline: {
                                  enabled: false
                                },
                                toolbar: {
                                    show: false
                                }
                            }"
                        [colors]="['#4191ff', 'rgba(65, 145, 255, 0.15)']"
                        [dataLabels]="{
                              enabled: false
                            }"
                        [fill]="{
                              opacity: 0.85,
                              colors: ['#4191ff', '#4191ff']
                            }"
                        [grid]="{
                            strokeDashArray: '5',
                            borderColor: 'rgba(125, 138, 156, 0.3)'
                        }"
                        [labels]="['January', 'February', 'March', 'April', 'May', 'June', 'July']"
                        [legend]="{ show: false }"
                        [series]="[
                              {
                                name: 'Net Profit',
                                data: [3.3, 3.1, 4.0, 5.8, 2.1, 3.6, 3.2]
                              },
                              {
                                name: 'Net Loss',
                                data: [2.1, 2.1, 2.8, 2.8, 4.3, 2.7, 1.4]
                              }
                            ]"

                        [stroke]="{
                              show: true,
                              width: 2,
                              colors: ['transparent']
                            }"
                ></apx-chart>
            </div>
        </div>
    </div>
    <div class="col-xl-6">
        <div class="card card-box mb-5">
            <div class="card-header">
                <div class="card-header--title">
                    <h4 class="font-size-lg mb-0 py-2 font-weight-bold">
                        Users list
                    </h4>
                </div>
                <div class="card-header--actions">
                    <div class="btn-group btn-group-sm" dropdown>
                        <button class="btn btn-sm dropdown-toggle no-caret btn-neutral-dark" dropdownToggle
                                type="button">
                            Export
                            <fa-icon [icon]="['fas', 'chevron-down']" class="opacity-8 font-size-xs ml-1"></fa-icon>
                        </button>
                        <div *dropdownMenu class="dropdown-menu dropdown-menu-xl dropdown-menu-right">
                            <ul class="nav nav-neutral-dark nav-pills flex-column px-3">
                                <li class="nav-item nav-item--header px-0">
                                    <span class="text-capitalize text-black font-size-md font-weight-bold">Export menu</span>
                                </li>
                                <li class="dropdown-divider"></li>
                                <li class="nav-item">
                                    <a [routerLink]="" class="nav-link">
                                        <span>View all reports</span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a [routerLink]="" class="nav-link active">
                                        <span>View active items</span>
                                        <div class="ml-auto badge badge-success">23</div>
                                    </a>
                                </li>
                                <li class="nav-item pt-4 nav-item--header">
                                    <span class="text-black font-weight-bold">Options</span>
                                </li>

                                <li class="nav-item">
                                    <a [routerLink]="" class="nav-link">
                                        <div class="nav-link-icon">
                                            <fa-icon [icon]="['fas', 'download']"></fa-icon>
                                        </div>
                                        <span>Download</span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a [routerLink]="" class="nav-link">
                                        <div class="nav-link-icon">
                                            <fa-icon [icon]="['far', 'file-excel']"></fa-icon>
                                        </div>
                                        <span>Export to CSV</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <apx-chart
                        [chart]="{
                                type: 'bar',
                                height: '280',
                                sparkline: {
                                  enabled: false
                                },
                                toolbar: {
                                    show: false
                                }
                            }"
                        [colors]="['#4191ff', 'rgba(65, 145, 255, 0.35)']"
                        [dataLabels]="{
                              enabled: false
                            }"
                        [fill]="{
                              opacity: 0.85,
                              colors: ['#4191ff', 'rgba(65, 145, 255, 0.35)']
                            }"
                        [grid]="{
                            strokeDashArray: '5',
                            borderColor: 'rgba(125, 138, 156, 0.3)'
                        }"
                        [labels]="['January', 'February', 'March', 'April', 'May', 'June', 'July']"
                        [legend]="{ show: false }"
                        [series]="[
                              {
                                name: 'Net Profit',
                                data: [3.3, 3.1, 4.0, 5.8, 2.1, 3.6, 3.2]
                              },
                              {
                                name: 'Net Loss',
                                data: [2.1, 2.1, 2.8, 2.8, 4.3, 2.7, 1.4]
                              }
                            ]"

                        [stroke]="{
                              show: true,
                              width: 2,
                              colors: ['transparent']
                            }"
                ></apx-chart>
                <div class="row">
                    <div class="col-md-6">
                        <div class="p-3">
                            <div class="mb-1 font-weight-bold">Orders</div>
                            <progressbar [animate]="true" [value]="34" class="progress-xs progress-animated-alt"
                                         type="primary">
                            </progressbar>
                            <div class="align-box-row progress-bar--label mt-1 text-muted">
                                <small class="text-dark">0</small>
                                <div class="ml-auto">100%</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="p-3">
                            <div class="mb-1 font-weight-bold">Sales</div>
                            <progressbar [animate]="true" [value]="51" class="progress-xs progress-animated-alt"
                                         type="success">
                            </progressbar>
                            <div class="align-box-row progress-bar--label mt-1 text-muted">
                                <small class="text-dark">0</small>
                                <div class="ml-auto">100%</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="p-3">
                            <div class="mb-1 font-weight-bold">Users</div>
                            <progressbar [animate]="true" [value]="29" class="progress-xs progress-animated-alt"
                                         type="warning">
                            </progressbar>
                            <div class="align-box-row progress-bar--label mt-1 text-muted">
                                <small class="text-dark">0</small>
                                <div class="ml-auto">100%</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="p-3">
                            <div class="mb-1 font-weight-bold">Customers</div>
                            <progressbar [animate]="true" [value]="76" class="progress-xs progress-animated-alt"
                                         type="danger">
                            </progressbar>
                            <div class="align-box-row progress-bar--label mt-1 text-muted">
                                <small class="text-dark">0</small>
                                <div class="ml-auto">100%</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
